import { CONSTANTS } from '@shared/constants';
import {
  VENUE_USERS_ROUTES_PATHS_FULL,
  VENUE_USERS_ROUTES_PATHS_PARTIALS,
} from './users/ven-users-routes-paths';
import { VENUE_CAMPAIGNS_ROUTES_PATHS_PARTIALS } from './ven-campaigns/ven-campaigns-routes-paths';
import { VENUE_ONE_MORE_QUESTION_ROUTES_PATHS_PARTIALS } from './ven-one-more-question/ven-one-more-question-routes-paths';

export const VENUE_SETTINGS_ROUTES_PATHS_PARTIALS = {
  BASE_PATH: `${CONSTANTS.ROUTES.VENUE}/:${CONSTANTS.ROUTE_PARAMS.VENUE_ID}/${CONSTANTS.ROUTES.SETTINGS}`,
  COPILOT: CONSTANTS.ROUTES.COPILOT,
  DETAILS: CONSTANTS.ROUTES.VENUE_DETAILS,
  FOODBACK_QUESTIONS: CONSTANTS.ROUTES.FOODBACK_QUESTIONS,
  USERS: VENUE_USERS_ROUTES_PATHS_PARTIALS.BASE_PATH,
  GOALS: CONSTANTS.ROUTES.GOALS,
  WHEEL_OF_FORTUNE: CONSTANTS.ROUTES.WHEEL_OF_FORTUNE,
  FLEXIBLE_PORTAL: CONSTANTS.ROUTES.FLEXIBLE_PORTAL,
  FLEXIBLE_PORTAL_ANALYTICS_SEGMENT: 'analytics',
  ONE_MORE_QUESTION: VENUE_ONE_MORE_QUESTION_ROUTES_PATHS_PARTIALS.BASE_PATH,
  CAMPAIGNS: VENUE_CAMPAIGNS_ROUTES_PATHS_PARTIALS.BASE_PATH,
  REPORT_ARCHIVE: CONSTANTS.ROUTES.REPORT_ARCHIVE,
};
export const VENUE_SETTINGS_ROUTES_PATHS_FULL = {
  COPILOT: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.COPILOT}`,
  DETAILS: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.DETAILS}`,
  FOODBACK_QUESTIONS: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.FOODBACK_QUESTIONS}`,
  ONE_MORE_QUESTION: {
    BASE_PATH: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.ONE_MORE_QUESTION}`,
  },
  CAMPAIGNS: {
    BASE_PATH: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.CAMPAIGNS}`,
  },
  USERS: {
    BASE_PATH: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.USERS}`,
    INVITE: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_USERS_ROUTES_PATHS_FULL.INVITE}`,
    EDIT: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_USERS_ROUTES_PATHS_FULL.EDIT}`,
    // The list is the users route's own index (`path: ''`), so there is no `/list` segment.
    LIST: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.USERS}`,
  },
  GOALS: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.GOALS}`,
  WHEEL_OF_FORTUNE: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.WHEEL_OF_FORTUNE}`,
  FLEXIBLE_PORTAL: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.FLEXIBLE_PORTAL}`,
  FLEXIBLE_PORTAL_ANALYTICS: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${CONSTANTS.ROUTES.FLEXIBLE_PORTAL_ANALYTICS}`,
  REPORT_ARCHIVE: {
    BASE_PATH: `${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_SETTINGS_ROUTES_PATHS_PARTIALS.REPORT_ARCHIVE}`,
  },
};
